import { Card, CardContent, CardHeader, CardTitle } from "@devhop/ui";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { formatKip } from "@/modules/cf-feed/presentation/ui/table-helpers";
import type { CfDashboardTrendPoint } from "../api/types";

type OrdersTrendChartProps = {
  data?: CfDashboardTrendPoint[];
  isLoading: boolean;
};

// แสดงวันที่แบบสั้น dd/MM จาก yyyy-MM-dd (ไม่ใช้ new Date — ตัด string ตรงๆ)
function shortDay(date: string): string {
  const [, m, d] = date.split("-");
  return `${d}/${m}`;
}

export function OrdersTrendChart({ data, isLoading }: OrdersTrendChartProps) {
  const chartData = (data ?? []).map((p) => ({
    ...p,
    label: shortDay(p.date),
  }));
  const hasData = chartData.some((p) => p.orders > 0 || p.revenue > 0);

  return (
    <Card className="h-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">ແນວໂນ້ມການຂາຍຕາມມື້</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && !data ? (
          <div className="h-[240px] w-full animate-pulse rounded bg-muted" />
        ) : !hasData ? (
          <div className="flex h-[240px] items-center justify-center text-muted-foreground text-sm">
            ຍັງບໍ່ມີຂໍ້ມູນ
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={240}>
            <AreaChart
              data={chartData}
              margin={{ top: 8, right: 8, left: -8, bottom: 0 }}
            >
              <defs>
                <linearGradient id="cfOrders" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#6366f1" stopOpacity={0.35} />
                  <stop offset="95%" stopColor="#6366f1" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis dataKey="label" tick={{ fontSize: 11 }} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={32} />
              <Tooltip
                formatter={(value, name) => {
                  const numericValue =
                    typeof value === "number" ? value : Number(value ?? 0);
                  return String(name) === "revenue"
                    ? [formatKip(numericValue), "ຍອດຂາຍ"]
                    : [numericValue, "ອໍເດີ"];
                }}
                labelClassName="text-xs"
                contentStyle={{ fontSize: 12 }}
              />
              <Area
                type="monotone"
                dataKey="orders"
                stroke="#6366f1"
                strokeWidth={2}
                fill="url(#cfOrders)"
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
